module.exports = __webpack_public_path__ + "static/img/mixaves_alpiste.5664dcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/mixaves_alpiste.jpg
// module id = ie3P
// module chunks = 0